import { Router, ActivatedRoute } from "@angular/router";
import { Component, OnInit } from "@angular/core";
import { LoginService } from "../service/login/login.service";
import { DatePipe } from "@angular/common";
import * as $ from "jquery";
declare var $: any;

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeComponent implements OnInit {
  effect = "scrollx";
  titleNew: any;
  imgId: any;
  titleNew1: any;
  imgId1: any;
  titleNew2: any;
  imgId2: any;
  type = "中心动态";
  type1 = "案例展示";
  type2 = "行业动态";
  type3 = "高分卫星数据";
  type4 = "其他国产卫星数据";
  type5 = "政策法规";
  type6 = "国外卫星数据";
  allTimeLook3: any;
  allTimeLook4: any;
  allTimeLook6: any;
  show = false;
  show1 = true;
  show2 = true;
  show3 = false;
  showBox = true;
  showBox1 = false;
  responsiveOptions: any;
  carousels = [];
  smallcarousels = [];
  items6carousels = [];
  items4carousels = [];

  items = [];
  industryItems = [];
  itemsUse = [];
  itemsUse1 = [];
  itemsbull = [];
  items2 = [];
  items3 = [];
  items4 = [];
  items5 = [];
  items6 = [];
  sumDay = [];
  home: any;

  dataSet = [];

  listOrigin = [];

  constructor(
    private service: LoginService,
    private router: Router,
    private route: ActivatedRoute,
    private datePipe: DatePipe
  ) {
    this.responsiveOptions = [
      { breakpoint: "1024px", numVisible: 3, numScroll: 3 },
      { breakpoint: "768px", numVisible: 2, numScroll: 2 },
      { breakpoint: "560px", numVisible: 1, numScroll: 1 },
    ];
  }

  private formatDate = (date: string): string => {
    return this.datePipe.transform(date, "yyyy/MM/dd") || "";
  };

  private processNewsItems = (res: any) => {
    const itemsArray = [];
    const carouselsArray = [];

    res["result"].forEach((e) => {
      const time = this.formatDate(e.time);
      const fileid = e.fileid.includes(",") ? e.fileid.split(",")[0] : e.fileid;

      itemsArray.push({
        content: e.content,
        fileid: e.fileid,
        id: e.id,
        level: e.level,
        state: e.state,
        time: time,
        title: e.title,
        type: e.type,
        launchDate: e.launchDate,
      });

      carouselsArray.push({
        img: fileid,
        title: e.title,
        type: e.type,
        time: time,
        content: e.content,
        fileid: e.fileid,
        launchDate: e.launchDate,
      });
    });

    return { itemsArray, carouselsArray };
  };

  private calculateDaysSinceLaunch = (itemsArray: any[], allTimeLook: any) => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    const currentDateNum = currentDate.getDate();

    itemsArray.forEach((item) => {
      const launchYear = Number(item.launchDate.slice(0, 4));
      const launchMonth = Number(item.launchDate.slice(5, 7));
      const launchDate = Number(item.launchDate.slice(8, 11));

      allTimeLook =
        currentYear * 365 +
        currentMonth * 30 +
        currentDateNum -
        (launchYear * 365 + launchMonth * 30 + launchDate);
      item.sumDay = allTimeLook;
    });
  };

  getNews = () => {
    this.service.getPicture().subscribe((res: any) => {
      const { itemsArray, carouselsArray } = this.processNewsItems(res);
      this.carousels = carouselsArray;
    });

    this.service.getNews(this.type).subscribe((res: any) => {
      const { itemsArray } = this.processNewsItems(res);
      this.items = itemsArray;
      this.imgId = this.items[0].fileid.split(",")[0];
      this.titleNew = this.items[0].title;
      this.service.getImg(this.items[this.items.length - 1]["fileid"]);
    });
  };

  getNews1 = () => {
    this.service.getNews(this.type1).subscribe((res: any) => {
      const { itemsArray, carouselsArray } = this.processNewsItems(res);
      this.items2 = itemsArray;
      this.itemsUse = carouselsArray;
    });
  };

  getNews2 = () => {
    this.service.getNews(this.type2).subscribe((res: any) => {
      const { itemsArray } = this.processNewsItems(res);
      this.industryItems = itemsArray;
      const lastItem = this.industryItems[this.industryItems.length - 1];
      this.imgId2 = lastItem.fileid;
      this.titleNew2 = lastItem.title;
    });
  };

  getNews3 = () => {
    this.service.getNews(this.type3).subscribe((res: any) => {
      const { itemsArray, carouselsArray } = this.processNewsItems(res);
      this.items3 = itemsArray;
      this.smallcarousels = carouselsArray;
      this.calculateDaysSinceLaunch(this.items3, this.allTimeLook3);
    });
  };

  getNews4 = () => {
    this.service.getNews(this.type4).subscribe((res: any) => {
      const { itemsArray, carouselsArray } = this.processNewsItems(res);
      this.items4 = itemsArray;
      this.items4carousels = carouselsArray;
      this.calculateDaysSinceLaunch(this.items4, this.allTimeLook4);
    });
  };

  getNews5 = () => {
    this.service.getNews(this.type5).subscribe((res: any) => {
      const { itemsArray } = this.processNewsItems(res);
      this.items5 = itemsArray;
    });
  };

  getNews6 = () => {
    this.service.getNews(this.type6).subscribe((res: any) => {
      const { itemsArray, carouselsArray } = this.processNewsItems(res);
      this.items6 = itemsArray;
      this.items6carousels = carouselsArray;
      this.calculateDaysSinceLaunch(this.items6, this.allTimeLook6);
    });
  };

  detail = (e) => {
    this.setLocalStorage(e);
    this.router.navigate(["/detail"]);
  };

  policydetail = (e) => {
    this.setLocalStorage(e);
    this.router.navigate(["/policyDetail"]);
  };

  private setLocalStorage = (e) => {
    localStorage.setItem("detailid", e.id);
    localStorage.setItem("detailtit", e.title);
    localStorage.setItem("detailtime", e.time);
    localStorage.setItem("detailcontent", e.content);
    localStorage.setItem("detailImg", e.fileid);
  };

  ngOnInit(): void {
    setTimeout(() => {
      this.effect = "fade";
    }, 4000);

    this.getNews();
    this.getNews1();
    this.getNews2();
    this.getNews3();
    this.getNews4();
    this.getNews5();
    this.getNews6();

    this.initMarquee("cr1ContentBox", "cr1Content", 60);
    this.initMarquee("cr2ContentBox", "cr2Content", 70);
  }

  private initMarquee = (containerId: string, contentId: string, speed: number) => {
    const container = document.getElementById(containerId);
    const content = document.getElementById(contentId);

    const Marquee = () => {
      container.scrollTop++;
      const newNode = document.createElement("div");
      newNode.innerHTML = content.innerHTML;
      newNode.onclick = () => window.open("#/detail");
      container.insertBefore(newNode, null);
    };

    let interval = setInterval(Marquee, speed);
    container.onmouseover = () => clearInterval(interval);
    container.onmouseout = () => (interval = setInterval(Marquee, speed));
  };

  isWithinThreeDays(itemTime: string): boolean {
    const currentTime = new Date();
    const itemDate = new Date(itemTime);
    const threeDaysInMs = 3 * 24 * 60 * 60 * 1000; // 3天的毫秒数
    
    return currentTime.getTime() - itemDate.getTime() < threeDaysInMs;
  }
}